import {Component, OnInit} from '@angular/core';

import {Evento} from './evento';
import {Inscricao} from "../inscricao/inscricao";
import {EventosService} from "./eventos.service";
import {AppComponent} from "../app.component";
import {Router} from "@angular/router";
import {AcessoService} from "../acesso/acesso.service";
import {URL_API} from './../constante';

@Component({
    selector: 'app-eventos',
    templateUrl: './eventos.component.html',
    styleUrls: ['./eventos.component.css'],
    providers: [EventosService, AcessoService]
})
export class EventosComponent extends AppComponent implements OnInit {

    eventos: any;
	inscricoes: Inscricao[]; 
    aplicacao: AppComponent;
	aluno: boolean = false;
	
	verificarAluno(aluno: any) : void {
		if (aluno)
			this.aluno = true;
		else {
			this.aluno = false;
			this.utils.exibirMensagem('Você não é aluno de graduação presencial da UFRJ!', 'info');
		}
	}

	edital_aberto(edital: Evento): boolean {
		if (!this.aluno)
			return false;
		let data: Date = new Date();
		
		if (data < new Date(edital.datainicio) || data > new Date(edital.datalimit))
			return false;
		return true;
	}
	
	buscarAluno(cpf: string): void {
		this.eventoService.buscarAluno(cpf.replace(/\D/g,"")).then(resp => this.verificarAluno(resp.aluno));
	}
	
	setInscricoes(dados: Inscricao[]) {
		let inscricoes: Inscricao[] = this.inscricoes = dados; 
		let eventos: Evento[] = this.eventos; 
		let numInscricoes: number = inscricoes.length;
		let numEventos: number = eventos.length;
		let i: number;
		
		while (--numInscricoes >= 0) {
			i = numEventos;
			while (--i >= 0) 
				if (inscricoes[numInscricoes].evento_id == eventos[i].id)
					eventos[i].inscrito = true;
		}
	}	

	link_imagem(edital: Evento): string {
		return URL_API + '/imagem/imagem/' + edital.id;
    }
	
    ngOnInit() {
		if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else {
			this.eventoService.get().then(evento => this.eventos = evento);
			this.inscricaoService.getInscricoes(this.user_id).then(dados => this.setInscricoes(dados));
			this.cadastroService.getUsuario(this.user_id).then(usuario => this.buscarAluno(usuario.cpf));	
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/eventos/eventos.component.ts